export default "__VITE_ASSET__DtbwipQT__"